<template>
	<tr>
		<td>
			{{ routeplan.User.FullName }}
		</td>

		<td>{{ formatDate(startDate) }}</td>

		<td>{{ formatDate(routeplan.Added) }}</td>
		<td>{{ formatDate(routeplan.Updated) }}</td>
		<td>{{ allTasksConfirmed(routeplan) ? '✔' : '❌'}}</td>
		<td>
			<b-link v-b-toggle="`collapse-${routeplan.Id}`">
			
				<span class="when-open">▲</span><span class="when-closed">▼</span>
			</b-link>

			<b-collapse :id="`collapse-${routeplan.Id}`">
			
				<b-table-simple bordered>
					<tr v-for="(day, index) in routeplan.Data.days" :key="index">
						<td>{{ formatDate(day.startDate) }}:</td>
						<td>
							<ol>
								<li v-for="(waypoint, index) in day.waypoints" :key="index">
									{{ waypoint.name }} {{ waypoint.type == 4 && waypoint.confirmed == true ? '✔' : waypoint.type == 4 ? '❌' : '' }}
								</li>
							</ol>					
						</td>
					</tr>
				</b-table-simple>
			</b-collapse>
		</td>
		<td>
			<b-col>
				<b-link class="float-right ml-3" @click.prevent="onViewClick" title="View">
					<b-icon font-scale="1.5" icon="eye"></b-icon>
				</b-link>

				<b-link class="float-right ml-3" @click.prevent="onUpdateClick" title="Edit">
					<b-icon font-scale="1.5" icon="pencil-square"></b-icon>
				</b-link>

				<b-link class="float-right" @click.prevent="onPrintClick" title="Download/Print">
					<b-icon font-scale="1.5" icon="file-earmark-richtext"></b-icon>
				</b-link>
			</b-col>
		</td>
	</tr>
</template>

<script>
// import shared functions
import { dateFuncs } from '@/globs.js';

export default {
	name: 'RoutePlanListRow',

	props: ['routeplan'],

	computed: {
		startDate() {
			if (this.routeplan.Data.days) {
				if (this.routeplan.Data.days[0].startDate != null) {
					return this.routeplan.Data.days[0].startDate;
				}
			}
		}
	},

	data() {
		return {
			detailsShowing: false
		};
	},

	methods: {
		onViewClick() {
			this.$emit('view', this.routeplan.Id);
		},

		onUpdateClick() {
			this.$emit('update', this.routeplan.Id);
		},

		onPrintClick() {
			this.$emit('print', this.routeplan.Id);
		},

		formatDate(date) {
			return dateFuncs.backEndDateFormat(date);
		},

		allTasksConfirmed(_routeplan) {
			let count = 0;
			let goodflag= true;
			_routeplan.Data.days.forEach((day, i) => {
				day.waypoints.forEach((task, i) => {							
					if (task.type == 4 ) {
						count++;
						if (task.confirmed != true)
						{ 					
							goodflag = false;
						}
					}
				});
			});

			if (count > 0) {
				return goodflag;
			} else {
				return false;
			}
		},


	}
};
</script>


// WEBPACK FOOTER //
// src/components/routeplan/routeplan-list-row.vue